import clsx from 'clsx';

// Components
import { ManageProfilesHeader } from '@/components/pages/socialprofiles/ManageProfilesWrapper/ManageProfilesHeader';

export function ManageProfilesWrapper({ header, className, children }) {
    return (
        <>
            <ManageProfilesHeader>{header}</ManageProfilesHeader>
            <div
                className={clsx(
                    'flex-1 rounded-lg bg-white p-5 dark:bg-icoDarkMode-deepBlack',
                    className
                )}>
                {children}
            </div>
        </>
    );
}
